import { getOrganisations } from '@/fsd/entities/organization';
import { routes } from '@/fsd/shared/config/routes/routesConfig';
import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';

export const getAfterAuthPagePath = async () => {
  const data = await queryClient.fetchQuery({
    queryKey: ['organisations'],
    queryFn: getOrganisations,
  });

  if (data.length > 0) {
    return routes.pnl.path;
  } else {
    return routes.organisations.path;
  }
};
